import PropTypes from 'prop-types';
import React from 'react';
import AvatarIcon from '../atoms/AvatarIcon';

const AvatarOverflow = ({ count }) => <AvatarIcon>{count > 0 ? <span>+{count}</span> : null}</AvatarIcon>;

AvatarOverflow.propTypes = {
    count: PropTypes.number,
};

export default AvatarOverflow;
